import {
  THEME_REQUEST,
  THEME_SUCCESS,
  THEME_FAIL,
} from "../actions/themeActions";


const initialState = {
  loading: false,
  restaurantId: null,
  restaurantName: "",
  theme: null,
  error: null,
};


const themeReducer = (
  state = initialState,
  action
) => {

  switch (action.type) {

    case THEME_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };


    case THEME_SUCCESS:

      return {
        ...state,
        loading: false,
        restaurantId:
          action.payload.restaurant_id,
        restaurantName:
          action.payload.restaurant_name || "",
        theme:
          action.payload.theme,
        error: null,
      };


    case THEME_FAIL:

      return {
        ...state,
        loading: false,
        theme: null,
        error: action.payload,
      };


    default:

      return state;
  }
};


export default themeReducer;